import { Component } from '@angular/core';

/**
 * Use as a placeholder until actual implementations are available.
 */
@Component({
  selector: 'app-empty',
  imports: [],
  template: ``,
  styles: ``,
})
export class EmptyComponent {}
